const createDeviceFormModel = {
  formId: 'createDeviceForm',
  formField: {
    name: {
      name: 'name',
      label: 'Nombre del Dispositivo*',
      requiredErrorMsg: 'El nombre es obligatorio',
    },
    description: {
      name: 'description',
      label: 'Descripción',
    },
    is_user_required: {
      name: 'is_user_required',
      label: '¿Requiere Identificación para calificar?',
      requiredErrorMsg: 'Este campo es obligatorio',
    },
    is_single_user: {
      name: 'is_single_user',
      label: '¿Es para un único usuario específico?',
    },
    is_multi_user: {
      name: 'is_multi_user',
      label: '¿Es para múltiples usuarios específicos?',
    },
    users: {
      name: 'users',
      label: 'Seleccionar Usuario(s)',
      requiredErrorMsg: 'Debe seleccionar al menos un usuario',
    },
    all_users: {
      name: 'all_users',
      label: 'Asignar a todos los usuarios',
    },
    logo_device: {
      name: 'logo_device',
      label: 'Logo del Dispositivo',
    },
    logo_quality: {
      name: 'logo_quality',
      label: 'Logo de Calidad e Icontec',
    },
  },
};

export default createDeviceFormModel;
